import { render, staticRenderFns } from "./newSingleSource.vue?vue&type=template&id=2779bab0&scoped=true"
import script from "./newSingleSource.vue?vue&type=script&lang=js"
export * from "./newSingleSource.vue?vue&type=script&lang=js"
import style0 from "./newSingleSource.vue?vue&type=style&index=0&id=2779bab0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2779bab0",
  null
  
)

export default component.exports